const langList={
    zh:'简体中文',
    en:'English',
    ko:'한국어',
}
export default langList